export const FORGOT = "/forgot";
export const PROFILE = "/profile";
export const RESET = "/reset";
export const SKILL_SCORE = "/skill-score";
export const INDIVIDUAL_SKILL_SCORE = "/individual-skill-score";
export const LOGIN = "/login";
export const COMPANY_LIST = "/company-list";
export const COMPANY_SETUP = "/company-setup";
export const DASHBOARD = "/";
export const USERS = "/users";
export const USERS_LIST = "/userlist";
export const USERS_GROUP = "/usergroup";
export const ROLES_PEMISSION = "/rolespermission";
export const TARGET = "/target";
export const UPDATES = "/updates";
export const TARGET_LIST = "/targetlist";
export const TEMPLATE = "/template";
export const DETAIL = "/detail";
export const OBJECTIVE = "/objective";
export const CHECKIN = "/checkin";
export const USERPROFILE = "/user-profile";
export const USEREDIT = "/user-edit";
export const CREATE_TARGET = "/target-create";
export const EDIT_TARGET = "/target-edit";
export const CREATE_TEMPLATE = "/create-template";
export const EDIT_TEMPLATE = "/edit-template";
export const COMPANY = "/company";
export const COMPANY_SETTINGS = "/company-settings";
export const CHECKIN_TEMPLATE = "/checkin-templates";
export const PREVIEW = "/preview";
export const VISION = "/vision";
export const EDIT = "/edit";
export const CREATE = "/create";
export const ONBOARDING = "/onboarding";
export const STRENGTH = "/strength";
export const FORGOT_ORGANIZATION = "/forgot-organization";
export const REPORTS = "/reports";
export const SUCCESS_STORIES = "/successstories";
export const PERFORMANCE_REVIEW = "/performancereview";
export const DEPARTMENTS = "/departments";
export const COACHING = "/coaching";
export const EXECUTIVE = "/executive";
export const OVERVIEW = "/overview";
export const BOARD = "/board";
export const USER_PROFILE = "/user-profile";
export const DETAILS = "/details";
export const MANUAL = "/manualgroup";
export const RULE = "/rulegroup";
export const ARCHIVE = "/archive";
export const CHECKINHIGHLIGHTED = "/checkinHighlighted";
